import React from "react";
import cx from "classnames";

type Props = {
  label: string;
  href: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const Link: React.FC<Props> = ({ label, href, className }): JSX.Element => {
  return (
    <a
      className={cx("flex flex-row justify-center font-nunito", className)}
      href={href}
    >
      {label}
    </a>
  );
};

export default Link;
